import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { resetProperties } from '../../../Vehicles/helpers';
import { AddVehicleModalBase } from '../../../Vehicles/pages/create/AddVehicleModals/VehicleBaseModal/AddVehicleModalBase';
import { Button } from '../../../../components/Buttons';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_VEHICLE } from '../../../Vehicles/constants';
import { selectNewVehicle, selectNewVehicleValue, selectVehicles } from '../../../Vehicles/selectors';
import { createVehicleWithProps, fromAutotelex, initiateVehicleCreate, setNewVehicleValue } from '../../../Vehicles/actions';
import { createInvoice, createProductInvoice, initiateProductInvoiceCreate } from '../../../Invoices/actions';
import { fetchCompany } from '../../../Companies/actions';
import { InvoiceCreate } from '../../../Invoices/pages/create';
import { ProductInvoiceCreate } from '../../components/ProductInvoiceCreate';
import { SelectCreditorModal } from '../../../Vehicles/pages/create/AddVehicleModals/AddCreditorModal/SelectVehicleCreditorCompany';
import { INVOICE_TYPES } from '../../../Invoices/constants';

const Container = styled.div`
  .button-wrapper {
    margin: 0 -12px;
  }
`;

const STATE = {
  isCreditorModal: false,
  isSecondModal: false,
  showAcceptDuplicate: false,
  acceptedForDuplicate: false,
};

class ProductInvoiceCreateModalsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
  }

  onCreditorModalConfirm() {
    this.setState({ isCreditorModal: false });
    this.save();
  }

  reset() {
    const resetTypes = resetProperties('addModal');
    this.setState({ ...STATE });
    this.props.resetValues(resetTypes);
  }

  save() {
    const dto = {
      separateInvoice: {
        vehicleId: this.props.vehicleId || null,
        direction: this.props.direction,
        subjectType: 'product',
        type: INVOICE_TYPES.INVOICE,
        [this.props.direction === 'incoming' ? 'incomingCompanyId' : 'outgoingCompanyId']: +this.props.companyId,
      },
    };

    this.props.create(dto);
  }

  confirmDuplicate = () => {
    this.setState({ acceptedForDuplicate: true, showAcceptDuplicate: false });
  };

  cancelAcceptDuplicate = () => {
    const resetTypes = resetProperties('addModal');
    this.setState({ showAcceptDuplicate: false, acceptedForDuplicate: false }, this.props.resetValues(resetTypes));
  };

  acceptDuplicateBody = () => ({
    cancel: () => this.cancelAcceptDuplicate(),
    confirm: () => this.confirmDuplicate(),
    isVisible: this.state.showAcceptDuplicate,
  });

  render() {
    return (
      <Container>
        {this.state.isCreditorModal && (
          <SelectCreditorModal reset={this.reset.bind(this)} onConfirm={this.onCreditorModalConfirm.bind(this)} />
        )}
        {/*{this.state.isSecondModal && this.props.values?.creditor && (*/}
        {/*  <ProductInvoiceCreate/>*/}
        {/*)}*/}
        {window.innerWidth <= 768 && (
          <div className="button-wrapper">
            <Button className="button-add" primary inline small onClick={() => this.setState({ isCreditorModal: true })}>
              + {this.lbl('vehicle.overview.addNewButton')}
            </Button>
          </div>
        )}
        {window.innerWidth > 768 && (
          <div className="button-wrapper">
            <Button className="button-add" primary inline onClick={() => this.setState({ isCreditorModal: true })}>
              + {this.lbl('vehicle.overview.addNewButton')}
            </Button>
          </div>
        )}
      </Container>
    );
  }
}

ProductInvoiceCreateModalsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
    values: selectNewVehicle(),
    allVehicles: selectVehicles(),
    companyId: selectNewVehicleValue('creditor_company'),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateProductInvoiceCreate());
    },
    create(dto) {
      dispatch(createProductInvoice(dto));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoiceCreateModals = compose(withConnect, withRouter)(ProductInvoiceCreateModalsComp);
